import { BehaviorSubject } from "rxjs";
import { roles } from "../shared/lists/roles";
import { Address } from "./address";
import { Company } from "./company";
import { Role } from "./role";
import { ObjectId } from "../shared/type-aliases/object-id";
import { IPerson } from "./person";
import { BOOLEAN } from "../shared/common-enums/boolean";

const SUPPORT_EMAILS = [
  'suporte@tecinco.com.br',
  // 'fc.felipecarriel@gmail.com',
  'goncalvesdacosta05@gmail.com',
];

export interface User extends IPerson {
  firebase?: string;
  rg?: string;
  emailIntegrated?: string;
  fcmTopic?: string;
  roles?: Role[];
  commission?: number;
  profession?: string;
  discount?: number;

  /** 1 - activated | 0 - inactivated */
  seeOs?: BOOLEAN;

  /** the _id of custom AccessProfile */
  profileId?: ObjectId;

  /** Used to define wicth menus are seleced to show into favorites quick access */
  quickAccess?: string[];

  /** When true, the side menu starts collapsed on every screen the user navigates to (desktop only) */
  sidenavCollapsedByDefault?: boolean;


  // absent in the API
  role?: number;
  oldRole?: number;
  stamp?: number;
}


export class MkgUser implements User {
  id?: string;
  _id?: string;
  firebase?: string;
  name?: string; // required
  lang?: number;
  gender?: number;
  birthday?: string;
  document?: string;
  rg?: string;
  phone1?: string;
  phone2?: string;
  email?: string; // required
  emailIntegrated?: string;
  address?: Address;
  maritalStatus?: number;
  photo?: string;
  fcmTopic?: string;
  roles?: Role[];
  available?: number;
  type?: 'Consumidor' | 'Revenda' | 'Fabricante';
  observation?: string;
  creditLimit?: number;
  commission?: number;
  discount?: number;
  quickAccess?: string[];
  sidenavCollapsedByDefault?: boolean;
  profileId?: string;

  /** 2 - activated | 1 - inactivated */
  seeOs?: BOOLEAN;

  /** local only */
  ownCompanies$ = new BehaviorSubject<Company[]>([]);
  /** local only */
  linkedCompanies$ = new BehaviorSubject<Company[]>([]);
  /** local only - indicate if user have no one campany */
  noCompanies$ = new BehaviorSubject(true);

  /** if user have a stamp, he still wasn't accepted into the company */
  stamp?: number;
  readonly isTecincoMember: boolean;

  constructor(apiObj, stamp?: number) {
    Object.assign(this, apiObj);
    /** @TODO use a property into database to know if user is a tecinco member */
    this.isTecincoMember = typeof this.email === 'string' && SUPPORT_EMAILS.some(key => this.email.includes(key));
    if (Number.isFinite(stamp)) {
      this.stamp = stamp;
    }
  }

  defineCompanies(companies: Company[]) {
    const ownCompanies = [];
    const linkedCompanies = [];
    for (const company of companies
      .sort((a, b) => a.currentState - b.currentState)
      .sort((a, b) => b.favorite - a.favorite)
    ) {
      if (company.owner === this.id) {
        ownCompanies.push(company);
      } else {
        linkedCompanies.push(company);
      }
    }
    this.ownCompanies$.next(ownCompanies);
    this.linkedCompanies$.next(linkedCompanies);
    this.noCompanies$.next(!companies.length);
  }

  isOwnerOf(company: Company) {
    return company.owner === this.id;
  }

  getRoleIn(company: Company) {
    if (this.isOwnerOf(company)) {
      return roles.admin.id;
    }
    const role = this.roles.find(r => r._id === company.id);
    if (role) {
      return role.rol;
    }
    return roles.mechanic.id;
  }

  /** local only */
  // get ownCompanies() {
  //   return this._ownCompanies
  //     .sort((a, b) => a.currentState - b.currentState)
  //     .sort((a, b) => b.favorite - a.favorite);
  // }

  /** local only */
  // get linkedCompanies() {
  //   return this._linkedCompanies
  //     .sort((a, b) => a.currentState - b.currentState)
  //     .sort((a, b) => b.favorite - a.favorite);
  // }

  /** local only */
  // get noCompanies() {
  //   return this._noCompanies;
  // }

  /** local only */
  get firstName() {
    return this.name.split(/\s/gm).shift();
  }


  toApi(): User {
    const apiUser: User = {
      id: this.id,
      firebase: this.firebase,
      name: this.name || "-",
      lang: this.lang,
      gender: this.gender,
      birthday: this.birthday,
      document: this.document && this.document?.length ? this.document.replace(/[\W]/gm, '') : "",
      rg: this.rg,
      phone1: this.phone1,
      phone2: this.phone2,
      email: this.email,
      emailIntegrated: this.emailIntegrated,
      address: this.address || {},
      maritalStatus: this.maritalStatus,
      photo: this.photo,
      fcmTopic: this.fcmTopic,
      roles: this.roles,
      available: this.available,
      type: this.type,
      observation: this.observation,
      creditLimit: this.creditLimit,
      commission: this.commission,
      discount: this.discount,
      quickAccess: this.quickAccess || [],
      sidenavCollapsedByDefault: this.sidenavCollapsedByDefault,
      profileId: this.profileId,
    }

    if (typeof this.seeOs === "boolean") {
      apiUser["seeOs"] = this.seeOs ? BOOLEAN.TRUE : BOOLEAN.FALSE;
    } else if (typeof this.seeOs === "number") {
      apiUser["seeOs"] = this.seeOs === BOOLEAN.TRUE ? BOOLEAN.TRUE : BOOLEAN.FALSE;
    } else {
      delete apiUser.seeOs;
    }

    return apiUser;
  }
}

// alias
export class Mechanic extends MkgUser { }
